var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-serif"},[(!this.isMobile(_vm.w.width))?_c('div',{staticClass:"desktop"},[_c('desktop')],1):_c('div',{staticClass:"mobile"},[_c('desktop')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }